var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStArrowRight = function SvgStArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25292D",
    d: "M8.133 3.146a.5.5 0 0 1 .707 0l4 4a.51.51 0 0 1 .07.09l.015.025c.01.018.02.037.027.056l.007.02a.46.46 0 0 1 .027.163l-.006-.079a.503.503 0 0 1 .006.068V7.5a.51.51 0 0 1-.006.079l-.004.02a.46.46 0 0 1-.017.064l-.007.02a.448.448 0 0 1-.042.082.484.484 0 0 1-.07.089l.044-.052a.503.503 0 0 1-.033.04l-.011.012-4 4a.5.5 0 0 1-.707-.708L11.279 8H2.5a.5.5 0 0 1-.492-.41L2 7.5a.5.5 0 0 1 .5-.5h8.779L8.133 3.854a.5.5 0 0 1-.058-.638z"
  })));
};
export default SvgStArrowRight;